import { render, staticRenderFns } from "./vantPointChangeRecord.vue?vue&type=template&id=91cbabdc&scoped=true"
import script from "./vantPointChangeRecord.vue?vue&type=script&lang=ts"
export * from "./vantPointChangeRecord.vue?vue&type=script&lang=ts"
import style0 from "./vantPointChangeRecord.vue?vue&type=style&index=0&id=91cbabdc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cbabdc",
  null
  
)

export default component.exports